import { IPrintFunctionParams, IPrePostProcessor } from "../../core/printinterface/PrintFunction";

export type { postProcessor, preProcessor, postProcessorMap };
export { PrintPrePostProcessor, printPrePostProcessor };

interface postProcessor {
    run: ( rendering:string, params:IPrintFunctionParams ) => string
}

interface preProcessor {
    run: (  mf:JQuery, params:IPrintFunctionParams) => void
}

interface postProcessorMap {
    [key:string]:postProcessor
}

interface preProcessorMap {
    [key:string]:preProcessor
}
class PrintPrePostProcessor {
    postProcessors: postProcessorMap = {};
    preProcessors: preProcessorMap = {};

    executePost( processor:IPrePostProcessor, rendering:string) : string {
        let runner = this.postProcessors[processor.processor];
        if (!runner) {
            return `Missing post processor: '${processor.processor}'`;
        }
        return runner.run( rendering, processor );
    }
    executePre( processor:IPrePostProcessor, mf:JQuery) : void {
        let runner = this.preProcessors[processor.processor];
        if (!runner) {
            console.log( `Missing pre processor: '${processor.processor}'` );
            return;
        }
        return runner.run( mf, processor );
    }
}


let printPrePostProcessor = new PrintPrePostProcessor();

// printPrePostProcessor.postProcessors["mergeColumns"] = { run: ( table ) => { return "this was a table" } }


// note to activate those you need to configure in the section (where you select the TABLE) the function as advanced options, e.g.
//   "postProcessors": [ { "processor": "removeEmptyRows" } ]

// example -> merge several columns into one
printPrePostProcessor.postProcessors["mergeColumns"] = {

    run: ( tableHtml:string, params:IPrintFunctionParams ) => { 
        let table = $(tableHtml)
        if (typeof params["source"] == "undefined" ) {
            return "mergeColumns - source columns missing";
        }
        if (typeof params["target"] == "undefined" ) {
            return "mergeColumns - target column missing";
        }

        // find the first row to do the stuff
      
        
        // iterate over all rows and do the thing
        let rows = table.children().children("tr");
        for (let row = 0; row<rows.length; row++) {
            let tds= $(rows[row]).children("td,th");
            let html ="";
            for (let col of params["source"]) {
                let colNumber = <number>col;
                if (colNumber<0) colNumber = tds.length + colNumber;
                html += tds[colNumber].innerHTML;
            }
            let targetNumber = <number>params["target"];
            if (targetNumber<0) targetNumber = tds.length + targetNumber;
            tds[targetNumber].innerHTML = html;
        }

        return table[0].outerHTML;
    } 
}

// example -> delete a column of a table
printPrePostProcessor.postProcessors["deleteColumn"] = {

    run: ( tableHtml:string, params:IPrintFunctionParams ) => { 
        let table = $(tableHtml)
        if (typeof params["column"] == "undefined" ) {
            return "deleteColumn - column missing";
        }
        
        // iterate over all rows and do the thing
        let rows = table.children().children("tr");
        for (let row of rows.toArray()) {
            let tds= $(row).children("td,th");
            let colNumber = <number>params["column"];
            if (colNumber<0) colNumber = tds.length + colNumber;
            tds[colNumber].remove();
        }

        return table[0].outerHTML;
    } 
}

// example delete some items from tree
printPrePostProcessor.preProcessors["removeInput"] = {
    run: ( mf:JQuery, params:IPrintFunctionParams ) => { 
        if (typeof params["items"] == "undefined" ) {
            console.log( "removeInput - items to remove missing");
        }
        for (let item of params["items"]) {
            $(`*[ref="${item}"]`, mf).remove();
        }
    }
}

// example to delete empty rows
printPrePostProcessor.postProcessors["removeEmptyRows"] = {  
    run: ( rendering ) => { 
        var table = $(rendering);  
        $("tr", table).each( (idx, row) => { 
            if (!$(row).text()) $(row).remove()
        }); 
        return table[0].outerHTML 
    }
}

// example -> replace content of cells of a given column
// optional parameters class and style as html is escaped
printPrePostProcessor.postProcessors["replaceCells"] = {

    run: ( tableHtml:string, params:IPrintFunctionParams ) => { 

        function doReplace( tds:JQuery, colNumber:number) {
            if ( tds.length>colNumber) {
                let html = tds[colNumber].innerHTML;
                
                let withValue = `<span class='${params["class"]?params["class"]:""}' style='${params["style"]?params["style"]:""}'>${params["with"]}</span>`;
                
                html = html.replace( new RegExp(params["pattern"],"g"), withValue);
                tds[colNumber].innerHTML = html;
            } else {
                console.log(`less columns in table (${tds.length}) than expected (${colNumber})` )
            }
        }
        // assume incoming can be a sequential with multiple  tables inside or directly a table: wrap the html in a div
        let section = $("<div>").html(tableHtml);

        if (typeof params["column"] == "undefined" ) {
            return "replaceCells - relative index of 'column' missing";
        }
        if (typeof params["pattern"] == "undefined" ) {
            return "replaceCells - 'pattern' to be replaced is missing";
        }
        if (typeof params["with"] == "undefined" ) {
            return "replaceCells - replacement 'with' is missing";
        }


        // find all top level tables
        let tables = $("table", section).filter(function() { return $(this).parents("table").length == 0; });

        for (let table of tables.toArray()) {
            // find the first row to do the stuff

            let startRow = ($("thead", $(table)).length)?0:1; // if there is a header row start with the first body row, else assume that the first row in the body is a header 
            if (typeof params["startRow"] != "undefined" ) { // allow user to overwrite
                startRow = params["startRow"];
            }

            // iterate over all rows in the body and do the thing
            var rows = $(table).children("tbody").children("tr");
            for (let row = startRow; row<rows.length; row++) {
                let tds= $("td", rows[row]);

                if ( params["column"] == "any" ) {
                    for( let col =0; col<tds.length; col++) {
                        doReplace( tds, col);
                    }
                } else {

                    let colNumber = <number>params["column"];
                    if (colNumber<0) colNumber = tds.length + colNumber;
                    doReplace( tds, colNumber);
                }
                
            }
        }

        return section.html();
    } 

    
}